import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  UnorderedList,
  ListItem,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import type { DeleteConflictResponse } from '../types';

interface DeleteConflictDialogProps {
  conflict: DeleteConflictResponse | null;
  isOpen: boolean;
  isDeleting?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Shown when deleting a clip that's still used by playlists (409). Lists the
 * affected playlists and lets the user move the clip to trash anyway.
 */
export function DeleteConflictDialog({
  conflict,
  isOpen,
  isDeleting,
  onClose,
  onConfirm,
}: DeleteConflictDialogProps) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('customContent.inUseTitle')}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text mb={3} color="gray.600">
            {t('customContent.inUseDescription')}
          </Text>
          {conflict && conflict.affectedPlaylists.length > 0 && (
            <UnorderedList spacing={1} color="gray.700">
              {conflict.affectedPlaylists.map((p) => (
                <ListItem key={p.id}>{p.name}</ListItem>
              ))}
            </UnorderedList>
          )}
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            {t('common.cancel')}
          </Button>
          <Button colorScheme="red" onClick={onConfirm} isLoading={isDeleting}>
            {t('customContent.moveToTrash')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default DeleteConflictDialog;
